import { config_settings } from '@/config.js';
import { updateColors } from '@/helpers/style.helpers';

export const generateTokenBodyRequest = (username, password) => {
  var bodyCredentials = new FormData();
  bodyCredentials.append('grant_type', 'password');
  bodyCredentials.append('username', username);
  bodyCredentials.append('password', password);
  bodyCredentials.append('id_store', config_settings.STORE);
  return bodyCredentials;
};

export const generateTokenBodywFacebookRequest = (facebookEmail, facebookToken) => {
  var bodyCredentials = new FormData();
  bodyCredentials.append('grant_type', 'password');
  bodyCredentials.append('username', facebookEmail);
  bodyCredentials.append('password', 'fromfbpass@uxtore6798');
  bodyCredentials.append('id_store', config_settings.STORE);
  bodyCredentials.append('facebook_token', facebookToken);
  return bodyCredentials;
};

export const generateTokenBodywGoogleRequest = (googleEmail, googleToken) => {
  var bodyCredentials = new FormData();
  bodyCredentials.append('grant_type', 'password');
  bodyCredentials.append('username', googleEmail);
  bodyCredentials.append('password', 'fromgooglepass@uxtore6798');
  bodyCredentials.append('id_store', config_settings.STORE);
  bodyCredentials.append('google_token', googleToken);
  return bodyCredentials;
};

export const generateRefreshTokenBodyRequest = () => {
  var refreshToken = localStorage.getItem('refresh_token');
  var refreshCredentials = new FormData();
  refreshCredentials.append('grant_type', 'refresh_token');
  refreshCredentials.append('refresh_token', refreshToken);
  refreshCredentials.append('id_store', config_settings.STORE);
  return refreshCredentials;
};

export const deleteTokens = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('setOauth2TypeUser');
};

export const setTokens = (token, refreshToken) => {
  localStorage.setItem('access_token', token);
  localStorage.setItem('refresh_token', refreshToken);
};

export const setOauth2TypeUser = (type) => {
  return localStorage.setItem('oauth2TypeUser', type);
};

export const getAccessToken = () => {
  return localStorage.getItem('access_token');
};

export const getRefreshToken = () => {
  return localStorage.getItem('refresh_token');
};

export const getOauth2TypeUser = () => {
  return localStorage.getItem('oauth2TypeUser');
};

export const getCartItems = () => {
  return JSON.parse(localStorage.getItem('iki-cart'));
};

export const deleteCartItems = () => {
  const products = [];
  localStorage.setItem('iki-cart', JSON.stringify(products));
};

export const setNiubizSecurityToken = (niubizSecurityToken) => {
  localStorage.setItem('niubizSecurityToken', niubizSecurityToken);
};

export const setCdpDetailsForVisanet = (jsonObject) => {
  localStorage.setItem('cdp_details_for_visanet', JSON.stringify(jsonObject));
};

export const saveConfigData = (configData) => {
  //try to save in vuex
  const {
    primarybgColor,
    primaryColor,
    secondarybgColor,
    secondaryColor,
    extradetailsColor,
    secondaryextradetailsColor,
  } = configData[0].designFlags;
  updateColors(
    primarybgColor,
    primaryColor,
    secondarybgColor,
    secondaryColor,
    extradetailsColor,
    secondaryextradetailsColor,
  );
};
